import axios from 'axios';
import { getConfig } from '../../utilities/api';

/** Adds to the DOM a new script pointing at the given `url`.
 *
 * @param {string} url      - A URL used for the script source.
 * @returns {Promise<any>}  - If the script loads successfully, we resolve; otherwise the promise rejects.
 */
const _addScript = (url) =>
    new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    });

/** Add all scripts that we can `GET` using the given `url` route.
 *
 * @param {string?} url     - A route used with a `GET` HTTP request; defaulting to Inspections’ `manifest.json`.
 * @param {string?} bundle  - The key to get the scripts; defaulting to `"app"`.
 * @returns {Promise}       - A promise that only resolves when all scripts are added.
 */
const _addManifest = async (isLocal) => {
    const bundle = 'app';
    const orchestratorConfig = await getConfig();
    console.log('manifest', orchestratorConfig);

    const url = `${orchestratorConfig.data.INSPECTIONS_WEBUI_PUBLIC_URL}/_nuxt/manifest.json`;
    const { entrypoints, publicPath } = isLocal
        ? (await axios.get(url)).data
        : (
              await axios.get(url, {
                  headers: {
                      'Cache-Control': 'no-cache, max-age=0, must-revalidate',
                  },
              })
          ).data;
    const { assets } = entrypoints[bundle];
    console.log({ entrypoints, publicPath, assets });
    for (const it of assets) await _addScript(publicPath + it);
};

/**
 * Loads the inspections application.
 * See the documentation here: https://single-spa.js.org/docs/configuration/#loading-function
 *
 * @param {boolean} isLocal True if the application is running in a local environment.
 * @returns {Promise<Module>} The single-spa inspections module.
 */
export const load = async (isLocal) => {
    await _addManifest(isLocal);
    return window['inspections'];
};
